import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { PatientSeparateResidenceId } from '@app/icare/entities/patient/schema/PatientSeparateResidence'
import { PatientSeparateResidenceOverview } from '@app/icare/routes/_app/patienten/$id/_edit/_residences/-components/PatientSeparateResidenceOverview'
import { entityParams } from '@pkg/db/utils'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_residences/aufenthaltsorte/$relation')({
  params: entityParams({ id: PatientId, relation: PatientSeparateResidenceId }),
  component: RouteComponent,
})

function RouteComponent() {
  const { id, relation } = Route.useParams()

  return <PatientSeparateResidenceOverview patientId={id} relationId={relation} />
}
